import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IncidentTypeResponse } from '../interfaces/incident-type-response.interface';
import { PagedTicketsResponse, TicketResponse } from '../interfaces/ticket-response.interface';
import { TicketTrackingResponse } from '../../my-orders/interfaces/ticket-tracking-response.interface';

const API_URL = environment.apiUrl;

@Injectable({ providedIn: 'root' })
export class TicketService {
  private http = inject(HttpClient);

  getCatIncidentsType(): Observable<IncidentTypeResponse[]> {
    return this.http.get<IncidentTypeResponse[]>(`${API_URL}/ticket/catIncidentsType`);
  }

  getTickets(pageNumber: number = 1, pageSize: number = 10, category?: string, searchTerm?: string): Observable<PagedTicketsResponse> {
    let params = new HttpParams()
      .set('pageNumber', pageNumber.toString())
      .set('pageSize', pageSize.toString());

    if (category) {
      params = params.set('category', category);
    }
    if (searchTerm) {
      params = params.set('searchTerm', searchTerm);
    }

    return this.http.get<PagedTicketsResponse>(`${API_URL}/ticket`, { params });
  }

  getTicket(id: string): Observable<TicketResponse> {
    return this.http.get<TicketResponse>(`${API_URL}/ticket/${id}`);
  }

  createTicket(catIncidentTypeId: string, description: string, file?: File): Observable<any> {
    const formData = new FormData();
    formData.append('catIncidentTypeId', catIncidentTypeId);
    formData.append('description', description);
    if (file) {
      formData.append('file', file);
    }
    return this.http.post(`${API_URL}/ticket/add`, formData);
  }

  getTicketTracking(ticketId: string): Observable<TicketTrackingResponse[]> {
    return this.http.get<TicketTrackingResponse[]>(`${API_URL}/ticket/${ticketId}/tracking`);
  }

  createTicketTracking(ticketId: string, description: string, file?: File): Observable<any> {
    const formData = new FormData();
    formData.append('ticketId', ticketId);
    formData.append('description', description);
    if (file) {
      formData.append('file', file);
    }
    return this.http.post(`${API_URL}/ticketTracking/add`, formData);
  }
}
